import { AlertTriangle, Mail, Phone } from "lucide-react";
import { Alert, AlertDescription } from "../ui/alert";
import { Button } from "../ui/button";

export default function InactiveNotice() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <Alert className="border-amber-200 bg-amber-50">
          <AlertTriangle className="h-5 w-5 text-amber-600" />
          <AlertDescription className="text-amber-800">
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-lg mb-2">Account Inactive</h3>
                <p className="text-sm leading-relaxed">
                  Your account is currently inactive. Please contact our admin team to reactivate
                  your account and resume using our services.
                </p>
              </div>

              <div className="space-y-2">
                <p className="text-sm font-medium">Contact Admin:</p>
                <div className="flex flex-col space-y-2">
                  <Button
                    variant="outline"
                    size="sm"
                    className="justify-start h-auto py-2"
                    onClick={() => window.open("mailto:matthew@eastcoastscholars.com", "_blank")}
                  >
                    <Mail className="h-4 w-4 mr-2" />
                    <span className="text-sm">matthew@eastcoastscholars.com</span>
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    className="justify-start h-auto py-2"
                    onClick={() => window.open("tel:+16317935978", "_blank")}
                  >
                    <Phone className="h-4 w-4 mr-2" />
                    <span className="text-sm">(631) 793-5978</span>
                  </Button>
                </div>
              </div>
            </div>
          </AlertDescription>
        </Alert>
      </div>
    </div>
  );
}
